exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app {\n  font-family: \"Avenir\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/* 公共样式 */\n* {\n  padding: 0;\n  margin: 0;\n}\nbody {\n  background: #fff;\n  /* 字体声明 */\n  font: normal 400 14px/1.5 Helvetica, sans-serif, STHeiTi;\n  color: #333;\n}\nul li,\nol li {\n  list-style: none;\n}\na {\n  text-decoration: none;\n  color: #333;\n}\ntable {\n  /* 细线边框 */\n  border-collapse: collapse;\n}\nem,\nstrong,\nb,\ni {\n  font-style: normal;\n  font-weight: 400;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 400;\n}\nimg {\n  /* ie8下蓝色边框 */\n  border: none;\n  /* 取消图片下间隙 */\n  vertical-align: middle;\n}\n.clearfix::after,\n.clearfix::before {\n  content: \"\";\n  line-height: 0;\n  font-size: 0;\n  height: 0;\n  display: block;\n  clear: both;\n}\n.icon {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/assets/style/less/commend.less
// module id = wG7e
// module chunks = 6